import { AutogenModelCompanyLookup, AutogenRowCompanyLookup } from "./autogen/AutogenModelCompanyLookup";

export class ModelCompanyLookup extends AutogenModelCompanyLookup<RowCompanyLookup> {
	constructor() {
		super(RowCompanyLookup);
	}
}

export class RowCompanyLookup extends AutogenRowCompanyLookup {
}